import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ja from './ja.json';
import en from './en.json';

i18n
 .use(initReactI18next)
 .init({
    resources: {
        ja: {translation: ja},
        en: {translation: en}
    },
    lng: "ja",
    fallbackLng: 'ja',
    debug: true,

    interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
    },
    react: { 
        useSuspense: false //   <---- this will do the magic
    }
 });

export default i18n;